/** Spanish for the system area. Keys are the exact English strings the UI renders. */
const system = {
  // Settings tabs (components/SettingsTabs.js)
  'Account': 'Cuenta',
  'Content': 'Contenido',
  'Deletion Requests': 'Solicitudes de eliminación',

  // Settings page
  'Settings': 'Configuración',
  'Manage your account settings and preferences.': 'Administre la configuración y las preferencias de su cuenta.',
  'Profile Information': 'Información del perfil',
  'First Name': 'Nombre',
  'Last Name': 'Apellido',
  'Email': 'Correo electrónico',
  'Saving...': 'Guardando...',
  'Save Profile': 'Guardar perfil',
  'Change Password': 'Cambiar contraseña',
  'Current Password': 'Contraseña actual',
  'Enter current password': 'Ingrese la contraseña actual',
  'New Password': 'Nueva contraseña',
  'Enter new password': 'Ingrese la nueva contraseña',
  'Confirm Password': 'Confirmar contraseña',
  'Confirm new password': 'Confirme la nueva contraseña',
  'Changing...': 'Cambiando...',
  'MedEffects — Version {version}': 'MedEffects — Versión {version}',
  'Enter both a first and a last name.': 'Ingrese un nombre y un apellido.',
  'Profile updated successfully!': '¡Perfil actualizado correctamente!',
  'Failed to update profile': 'No se pudo actualizar el perfil',
  'Please fill in all password fields': 'Complete todos los campos de contraseña',
  'New passwords do not match': 'Las contraseñas nuevas no coinciden',
  'Password must be at least 12 characters and include an uppercase letter, a lowercase letter, a number, and a special character (@$!%*?&#).':
    'La contraseña debe tener al menos 12 caracteres e incluir una letra mayúscula, una letra minúscula, un número y un carácter especial (@$!%*?&#).',
  'Password changed successfully!': '¡Contraseña cambiada correctamente!',
  'Failed to change password': 'No se pudo cambiar la contraseña',
  'We could not change your password. Check your current password and the new password requirements, then try again.':
    'No pudimos cambiar su contraseña. Revise su contraseña actual y los requisitos de la nueva contraseña, e inténtelo de nuevo.',
  'Too many password change attempts. Please wait a minute and try again.':
    'Demasiados intentos de cambiar la contraseña. Espere un minuto e inténtelo de nuevo.',
  // Server sentences the Settings page can show (auth.service.ts, change-password.dto.ts, users.service.ts)
  'Current password is incorrect': 'La contraseña actual es incorrecta',
  'User not found': 'Usuario no encontrado',
  'Password must contain at least one uppercase letter, one lowercase letter, one number, and one special character (@$!%*?&#)':
    'La contraseña debe contener al menos una letra mayúscula, una letra minúscula, un número y un carácter especial (@$!%*?&#)',
  'newPassword must be longer than or equal to 12 characters': 'La nueva contraseña debe tener al menos 12 caracteres',
  'currentPassword should not be empty': 'La contraseña actual no debe estar vacía',
  'You do not have permission to access this resource': 'No tiene permiso para acceder a este recurso',
  'Forbidden resource': 'Recurso prohibido',

  // Deletion requests
  'Account Deletion Requests': 'Solicitudes de eliminación de cuenta',
  'Requests submitted from the public deletion page. Verify and process within 30 days, then mark as completed.':
    'Solicitudes enviadas desde la página pública de eliminación. Verifíquelas y procéselas en un plazo de 30 días y luego márquelas como completadas.',
  'Search': 'Buscar',
  'Email...': 'Correo electrónico...',
  'Status': 'Estado',
  'All Statuses': 'Todos los estados',
  'Clear': 'Limpiar',
  '{total} total request': '{total} solicitud en total',
  '{total} total requests': '{total} solicitudes en total',
  'Requested': 'Fecha de solicitud',
  'Actions': 'Acciones',
  'Loading...': 'Cargando...',
  'No deletion requests found': 'No se encontraron solicitudes de eliminación',
  'Mark Completed': 'Marcar como completada',
  'Reject': 'Rechazar',
  'Reopen': 'Reabrir',
  'Could not update the request. Please try again.': 'No se pudo actualizar la solicitud. Inténtelo de nuevo.',
  'Deletion request not found': 'Solicitud de eliminación no encontrada',
  'Page {page} of {totalPages}': 'Página {page} de {totalPages}',
  'Previous': 'Anterior',
  'Next': 'Siguiente',

  // Content management
  'Content Management': 'Gestión de contenido',
  'Manage app content pages (Help, Terms, Privacy)': 'Administre las páginas de contenido de la aplicación (Ayuda, Términos, Privacidad)',
  'Help & Support': 'Ayuda y soporte',
  'Terms of Service': 'Términos del servicio',
  'Privacy Policy': 'Política de privacidad',
  'No content yet': 'Aún no hay contenido',
  'Phone: {phone}': 'Teléfono: {phone}',
  'Email: {email}': 'Correo electrónico: {email}',
  'Edit': 'Editar',
  'Edit: {name}': 'Editar: {name}',
  'Update content shown in the mobile app': 'Actualice el contenido que se muestra en la aplicación móvil',
  'Failed to save': 'No se pudo guardar',
  'Title': 'Título',
  'Enter content text...': 'Ingrese el texto del contenido...',
  'Phone Number': 'Número de teléfono',
  'e.g. +1 (800) 123-4567': 'p. ej. +1 (800) 123-4567',
  'Email Address': 'Dirección de correo electrónico',
  'e.g. support@medeffects.com': 'p. ej. support@medeffects.com',
  'URL (opens in device browser)': 'URL (se abre en el navegador del dispositivo)',
  'Cancel': 'Cancelar',
  'Save': 'Guardar',

  // Audit logs
  'Audit Logs': 'Registros de auditoría',
  // The role code under the user's email ('admin' and 'clinic' live in orders.js)
  'sales_rep': 'representante de ventas',
  'patient': 'paciente',
  'HIPAA compliance activity tracking': 'Seguimiento de actividad para el cumplimiento de HIPAA',
  "Today's Events": 'Eventos de hoy',
  'This Week': 'Esta semana',
  'Failed Logins (7d)': 'Inicios de sesión fallidos (7 días)',
  'Email, description, endpoint...': 'Correo electrónico, descripción, punto de conexión...',
  'Action': 'Acción',
  'All Actions': 'Todas las acciones',
  'Resource': 'Recurso',
  'All Resources': 'Todos los recursos',
  'From': 'Desde',
  'To': 'Hasta',
  '{total} total events': '{total} eventos en total',
  'Time': 'Hora',
  'User': 'Usuario',
  'Description': 'Descripción',
  'IP': 'Dirección IP',
  'No audit logs found': 'No se encontraron registros de auditoría',

  // Integrations
  'Integrations': 'Integraciones',
  'Outbound connections this deployment holds on your behalf.': 'Conexiones salientes que esta implementación mantiene en su nombre.',
  'Order forms': 'Formularios de pedido',
  'Order forms - {transport}': 'Formularios de pedido - {transport}',
  'The mailbox vendors see in the From line, and where their replies land.':
    'El buzón que los proveedores ven en la línea De, y donde llegan sus respuestas.',
  'Configured': 'Configurado',
  'Not configured': 'No configurado',
  'Connected': 'Conectado',
  'Configured - not connected': 'Configurado - no conectado',
  'No read permission': 'Sin permiso de lectura',
  'Reading outbound mail status...': 'Leyendo el estado del correo saliente...',
  'Could not read the outbound mail status.': 'No se pudo leer el estado del correo saliente.',
  'Sending as': 'Enviando como',
  'No mailbox is available on the {transport} transport.': 'No hay ningún buzón disponible en el transporte {transport}.',
  'Transport: {transport} (MAIL_TRANSPORT={value})': 'Transporte: {transport} (MAIL_TRANSPORT={value})',
  'An order form sent now would be refused - see what is missing below.':
    'Un formulario de pedido enviado ahora sería rechazado - vea lo que falta a continuación.',
  'Deployment configuration': 'Configuración de la implementación',
  'Set': 'Definida',
  'Not set in Render. The Directory (tenant) ID on the Entra app registration.':
    'No definida en Render. El ID de directorio (inquilino) en el registro de la aplicación de Entra.',
  'Not set in Render. The Application (client) ID on the Entra app registration.':
    'No definida en Render. El ID de aplicación (cliente) en el registro de la aplicación de Entra.',
  'Not set in Render. Copy the secret Value, not the Secret ID - Entra shows them in adjacent columns and only the Value works.':
    'No definida en Render. Copie el Valor del secreto, no el ID del secreto - Entra los muestra en columnas contiguas y solo el Valor funciona.',
  'Not set in Render. The mailbox to send as, e.g. support@medeffectsllc.com.':
    'No definida en Render. El buzón desde el que se envía, p. ej. support@medeffectsllc.com.',
  'Configured is not the same as working.': 'Configurado no significa que funcione.',
  'These four values are present, which is all this check knows - it never contacts Microsoft. An expired client secret reports exactly the same state and fails on the first send. To prove the credential, POST /admin/mail/test with a recipient; it sends one diagnostic message and contacts no vendor.':
    'Estos cuatro valores están presentes, que es todo lo que esta comprobación sabe - nunca contacta a Microsoft. Un secreto de cliente vencido informa exactamente el mismo estado y falla en el primer envío. Para probar la credencial, haga POST /admin/mail/test con un destinatario; envía un mensaje de diagnóstico y no contacta a ningún proveedor.',
  'Google mailbox': 'Buzón de Google',
  'The Google OAuth grant. What it is used for depends on the outbound transport above.':
    'La autorización OAuth de Google. Para qué se usa depende del transporte saliente indicado arriba.',
  'Reads the BLS shipping notifications that arrive at {mailbox} and are redirected here. It does not send anything.':
    'Lee las notificaciones de envío de BLS que llegan a {mailbox} y se redirigen aquí. No envía nada.',
  'the sending mailbox': 'el buzón de envío',
  'Sends vendor order forms, and reads BLS shipping notifications.':
    'Envía formularios de pedido a proveedores y lee las notificaciones de envío de BLS.',
  'Reading connection status...': 'Leyendo el estado de la conexión...',
  'Could not read the Google connection status.': 'No se pudo leer el estado de la conexión con Google.',
  'Authorized mailbox': 'Buzón autorizado',
  'Authorized {when}': 'Autorizado el {when}',
  'Granted: {scopes}': 'Permisos otorgados: {scopes}',
  'This connection has no read permission, so shipping notifications cannot be read and tracking numbers will not appear on orders. It was authorized before reading was needed. Connect again below - the consent screen now includes Read.':
    'Esta conexión no tiene permiso de lectura, por lo que no se pueden leer las notificaciones de envío y los números de seguimiento no aparecerán en los pedidos. Se autorizó antes de que se necesitara la lectura. Vuelva a conectar más abajo - la pantalla de consentimiento ahora incluye Lectura.',
  'Not set in Render. Add it from the Google Cloud OAuth client, then redeploy.':
    'No definida en Render. Agréguela desde el cliente OAuth de Google Cloud y vuelva a implementar.',
  'Not set in Render. Shown only once when the OAuth client is created.':
    'No definida en Render. Se muestra una sola vez al crear el cliente OAuth.',
  'Not set in Render. Must match an Authorized redirect URI on the OAuth client exactly.':
    'No definida en Render. Debe coincidir exactamente con un URI de redirección autorizado en el cliente OAuth.',
  'Connecting is blocked until all three are set on the backend. They are read at startup, so finish the Render changes and let the service redeploy first.':
    'La conexión está bloqueada hasta que las tres estén definidas en el backend. Se leen al iniciar, así que termine los cambios en Render y deje que el servicio se vuelva a implementar primero.',
  'Creating link...': 'Creando enlace...',
  'Reconnect a different mailbox': 'Reconectar otro buzón',
  'Connect Google mailbox': 'Conectar buzón de Google',
  'Check connection': 'Comprobar conexión',
  'Could not create an authorization link.': 'No se pudo crear un enlace de autorización.',
  'The server returned no authorization link.': 'El servidor no devolvió ningún enlace de autorización.',
  // Server sentences from /admin/gmail/connect (gmail.service.ts)
  'GMAIL_CLIENT_ID / GMAIL_CLIENT_SECRET are not both set on this deployment.':
    'GMAIL_CLIENT_ID / GMAIL_CLIENT_SECRET no están ambas definidas en esta implementación.',
  'GMAIL_REDIRECT_URI is not set. Set it to the exact callback URL registered as an Authorized redirect URI on the Google Cloud OAuth client, then redeploy.':
    'GMAIL_REDIRECT_URI no está definida. Defínala con la URL de retorno exacta registrada como URI de redirección autorizado en el cliente OAuth de Google Cloud y vuelva a implementar.',
  'Authorization link': 'Enlace de autorización',
  'Expired': 'Vencido',
  'Expires in {time}': 'Vence en {time}',
  'This link has passed its 10 minute limit and will be rejected. Click Connect Google mailbox again for a fresh one.':
    'Este enlace superó su límite de 10 minutos y será rechazado. Haga clic de nuevo en Conectar buzón de Google para obtener uno nuevo.',
  'Single use, 10 minute limit. It carries no MedEffects credential, so it is safe to send to whoever holds the mailbox password - they sign in, not you.':
    'De un solo uso, con límite de 10 minutos. No contiene ninguna credencial de MedEffects, por lo que es seguro enviarlo a quien tenga la contraseña del buzón - esa persona inicia sesión, no usted.',
  'Open Google consent screen': 'Abrir la pantalla de consentimiento de Google',
  'Copied': 'Copiado',
  'Copy link': 'Copiar enlace',
  'On the Google screen': 'En la pantalla de Google',
  'Sign in as the mailbox you want to connect, and nothing else. Whichever account signs in is the one that gets connected.':
    'Inicie sesión con el buzón que desea conectar, y con ningún otro. La cuenta que inicie sesión es la que quedará conectada.',
  '"Google hasn\'t verified this app" is expected for an internal tool. Choose Advanced, then continue.':
    '"Google no ha verificado esta aplicación" es lo esperado para una herramienta interna. Elija Avanzado y luego continúe.',
  'Leave every checkbox ticked, Read included. If Read is unticked, shipping notifications cannot be read and tracking numbers stop appearing.':
    'Deje todas las casillas marcadas, incluida Lectura. Si Lectura está desmarcada, no se podrán leer las notificaciones de envío y los números de seguimiento dejarán de aparecer.',
  'Come back here and choose Check connection.': 'Vuelva aquí y elija Comprobar conexión.',
  'Worth knowing': 'Conviene saber',
  'Nothing on this page enables sending.': 'Nada en esta página habilita el envío.',
  'Order forms stay blocked until VENDOR_EMAIL_ENABLED is set to the exact string "true", and every send still needs an admin confirmation after reading a preview.':
    'Los formularios de pedido permanecen bloqueados hasta que VENDOR_EMAIL_ENABLED tenga exactamente el valor "true", y cada envío sigue necesitando la confirmación de un administrador tras leer una vista previa.',
  'The client secret expires.': 'El secreto de cliente vence.',
  'Entra app secrets have a fixed lifetime, and when this one lapses order forms fail with AADSTS7000222 while everything else keeps working normally. Note the expiry date on the app registration and rotate before it.':
    'Los secretos de aplicación de Entra tienen una vigencia fija, y cuando este caduque los formularios de pedido fallarán con AADSTS7000222 mientras todo lo demás sigue funcionando con normalidad. Anote la fecha de vencimiento en el registro de la aplicación y rótelo antes.',
  'Replies land on the vendor thread.': 'Las respuestas llegan al hilo del proveedor.',
  '{mailbox} is the address on every historical vendor thread, so a vendor replying to an order form continues the conversation where the rest of the history already is.':
    '{mailbox} es la dirección de todos los hilos históricos con proveedores, así que un proveedor que responde a un formulario de pedido continúa la conversación donde ya está el resto del historial.',
  'The Microsoft mailbox': 'El buzón de Microsoft',
  'Tracking notifications arrive at the Microsoft mailbox,': 'Las notificaciones de seguimiento llegan al buzón de Microsoft,',
  'not at the Google one. An Outlook rule on it redirects the two BLS senders to the Google mailbox so the app can read them - redirect, not forward, which is what keeps the original sender and message id the matcher depends on. Deleting that rule stops tracking numbers without any error appearing here.':
    'no al de Google. Una regla de Outlook en ese buzón redirige a los dos remitentes de BLS al buzón de Google para que la aplicación pueda leerlos - redirigir, no reenviar, que es lo que conserva el remitente original y el id de mensaje de los que depende el emparejador. Eliminar esa regla detiene los números de seguimiento sin que aparezca ningún error aquí.',
  'Replies go to the sending mailbox,': 'Las respuestas van al buzón de envío,',
  'which is not the address on the historical vendor threads. Confirm a vendor received the first send before relying on this channel.':
    'que no es la dirección de los hilos históricos con proveedores. Confirme que un proveedor recibió el primer envío antes de confiar en este canal.',
  'If the Google connection starts failing about a week after connecting,':
    'Si la conexión con Google empieza a fallar alrededor de una semana después de conectarla,',
  'the Google Cloud app is still in Testing. Google expires those refresh tokens after 7 days. Publish the app, then connect once more.':
    'la aplicación de Google Cloud sigue en estado de prueba (Testing). Google invalida esos tokens de actualización a los 7 días. Publique la aplicación y luego conéctela una vez más.',
  'To revoke the Google grant,': 'Para revocar la autorización de Google,',
  'the mailbox owner removes MedEffects at myaccount.google.com/permissions. There is no disconnect button here because only Google can actually sever it.':
    'el propietario del buzón elimina MedEffects en myaccount.google.com/permissions. Aquí no hay botón de desconexión porque solo Google puede cortarla realmente.',

  // Deletion Requests: the raw status keys shown as the filter options and the row badge.
  'pending': 'pendiente',
  'completed': 'completada',
  'rejected': 'rechazada',
};

export default system;
